/**
 * Three bouncing dots — the lightweight loading indicator used where a full
 * centred <Loading /> block would be too heavy (cart panels, hover previews).
 *
 * Also composed by <Loading /> itself, so the two stay visually identical.
 */
export default function LoadingDots({ className = "" }) {
  return (
    <div className={`flex justify-center space-x-1 ${className}`}>
      {["0ms", "150ms", "300ms"].map((delay) => (
        <div
          key={delay}
          className="w-2 h-2 bg-smiles-orange rounded-full animate-bounce"
          style={{ animationDelay: delay }}
        ></div>
      ))}
    </div>
  );
}
